import { render, staticRenderFns } from "./CreatePermission.vue?vue&type=template&id=7088d076&scoped=true"
import script from "./CreatePermission.vue?vue&type=script&lang=js"
export * from "./CreatePermission.vue?vue&type=script&lang=js"
import style0 from "./CreatePermission.vue?vue&type=style&index=0&id=7088d076&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7088d076",
  null
  
)

export default component.exports